import React from 'react'
import { Typography, List } from '@mui/material'

import DomainListItemExtended from '../DomainListItemExtended'
import LoadingIndicator from '../../../../../../../common/components/LoadingIndicator'

const ListDomainsStep = ({ isAddingDomain, domains, handleStartVerification, viewStyles }) => {
  if (isAddingDomain) {
    return (
      <Typography sx={viewStyles.noDomainsText}>
        <LoadingIndicator />
      </Typography>
    )
  }
  return (
    <>
      {domains.length === 0 && !isAddingDomain && (
        <Typography sx={viewStyles.noDomainsText}>
          No domains added yet. Add your first domain to get started.
        </Typography>
      )}
      <List sx={viewStyles.domainList}>
        {domains.map(domain => (
          <DomainListItemExtended key={domain.domain} domain={domain} onVerifyClick={handleStartVerification} />
        ))}
      </List>
    </>
  )
}

export default ListDomainsStep
